export function getStyleForClientRootContainer(backgroundImageURL, adaptiveMobileSize, isMobileVersion) {
    const containerStyle = {
      backgroundSize: "100% 100%",
    };
    if (isMobileVersion && adaptiveMobileSize && adaptiveMobileSize.width && adaptiveMobileSize.height) {
      containerStyle.width = `${adaptiveMobileSize.width}px`;
      containerStyle.height = `${adaptiveMobileSize.height}px`;
    } else {
      containerStyle.width = window.innerWidth;
      containerStyle.height = window.innerHeight;
    }
    if (backgroundImageURL) {
      containerStyle.backgroundImage = `url(${backgroundImageURL})`;
    }
    return containerStyle;
}